import { Range } from 'utils/range';

const rangeRegex = /\/(pax|besta|platsa|eket|smastad|ivar|bror|billy|ladmakare|kallax|boaxel|elvarli|jonaxel|knoxhult|aurdal)\//;

/*
 * Param customSearch can be used when we want to specify a stale or previous location state instead of the current global location object.
 * A common use case could be that we want to use the location object from react router after a redirect have taken place where the current location have been overwritten.
 */
export const getQuery = (customSearch?: string) => {
  return new URLSearchParams(customSearch ? customSearch : window.location.search);
};

export const getRange = () => {
  const query = getQuery();
  const range = query.get('range') || location.pathname.match(rangeRegex)?.[1];
  return (range || 'pax') as Range;
};

export const getStoreId = () => {
  const storeIdCheck = (id: string): string => {
    const regex = new RegExp('(\\d{3,5})');
    const foundStoreId = regex.exec(id);

    return foundStoreId && foundStoreId?.length > 0 ? foundStoreId[0] : '';
  };
  const storeIdFromQuery = getQuery().get('storeId');
  return storeIdFromQuery ? storeIdCheck(storeIdFromQuery) : null;
};

export const getKvadratFeatures = () => {
  const enableKvadratFeatureFlags = getQuery().get('enableKvadratFeatureFlags');
  const enableKvadratFeatures = enableKvadratFeatureFlags?.split(',').reduce((acc, curr) => {
    return { ...acc, [curr]: true };
  }, {});

  return enableKvadratFeatures;
};

//This is used to tell the IKEA account service where to redirect after a successful login
//We are removing state and code query parameters when logging into IKEA account to avoid double code answers in url
export const stripURLOfQueryParameters = (params: string[]) => {
  const url = new URL(window.location.href);
  params.filter(param => {
    if (url.searchParams.has(param)) {
      return url.searchParams.delete(param);
    }
  });
  return url.href;
};

export const checkURLQueryParameters = (params: string[]) => {
  const url = new URL(window.location.href);
  params.filter(param => {
    if (url.searchParams.has(param)) {
      return true;
    }
  });
  return false;
};

export const rangeIsPax = () => {
  return getRange() === 'pax';
};

export const rangeIsPlatsa = () => {
  return getRange() === 'platsa';
};

export const rangeIsSmastad = () => {
  return getRange() === 'smastad';
};

export const rangeIsIvar = () => {
  return getRange() === 'ivar';
};

export const rangeIsBesta = () => {
  return getRange() === 'besta';
};

export const rangeIsBror = () => {
  return getRange() === 'bror';
};

export const rangeIsEket = () => {
  return getRange() === 'eket';
};

export const rangeIsBilly = () => {
  return getRange() === 'billy';
};

export const rangeIsKallax = () => {
  return getRange() === 'kallax';
};

export const rangeIsBoaxel = () => {
  return getRange() === 'boaxel';
};

export const rangeIsLadmakare = () => {
  return getRange() === 'ladmakare';
};

export const rangeIsElvarli = () => {
  return getRange() === 'elvarli';
};

export const rangeIsKnoxhult = () => {
  return getRange() === 'knoxhult';
};

export const rangeIsAurdal = () => {
  return getRange() === 'aurdal';
};

export const e2e = () => {
  return getQuery().get('e2e') === 'true';
};

export const genericMode = () => {
  return getQuery().get('generic') === 'true';
};
